<!-- todo: register as a global component -->
<template>
    <div class="ep-banner" :class="bannerClass">
        <i v-if="icon" :class="`fa fa-${icon} mr-5`"></i>
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'EpBanner',

    props: {
        variant: {
            default: 'info',
            type: String,
            validator: value => ['info', 'success', 'warning', 'danger'].includes(value),
        },

        icon: {
            default: null, // use font awesome icons
            type: String,
        },
    },

    computed: {
        bannerClass () {
            return `ep-banner-${this.variant}`;
        },
    },
}
</script>
